module.exports = __webpack_public_path__ + "img/ghIcon2.aa030b83.png";